import { Component, OnInit } from '@angular/core';
import { EVENTS, IMAGE, MYEVENTS } from 'src/app/config';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/api.service';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { iconpack } from 'src/icons';
import { ShareService } from '@ngx-share/core';
import { WindowRefService } from 'src/app/window-ref/window-ref.service';
@Component({
    selector: 'app-event',
    templateUrl: './event.component.html',
    styleUrls: ['./event.component.css'],
    providers: [WindowRefService],
    
})
export class EventComponent implements OnInit {
  event: any;
  uid: any;
  eid: any;
  url: any;
  loader:boolean;
  page:boolean;
  transaction: any;
  imageUrl: any;
  showPaymentMethod:boolean = false;
  utrNumber:string = "";
  constructor(private api: ApiService, private route: ActivatedRoute,private router:Router,
     public share: ShareService, library: FaIconLibrary, private winRef: WindowRefService,
    ) {
          library.addIcons(...iconpack);
          this.uid = this.api.uid;
          if(!this.uid){
            setTimeout(() => {
              this.router.navigate(['/login']);
            },1000);
          }
         // this.event = JSON.parse(this.api.getEvent());
          this.route.params.subscribe(params => {
            this.eid = params.id;
            this.api.Get(EVENTS).then(data => {
              this.page=true;
              this.loader=false;
              this.event = data['data']['data'];
              this.event = this.event.find(x => x.id == this.eid);
              this.event['url'] = IMAGE+"events/";
            }).catch(d=>{
              if( d.status == 503){
                this.api.onFail('Your session is expired please login again','Login');
                this.api.setGoto();
                this.api.setlogin(0);
                this.api.logout();
                setTimeout(() => {
                this.router.navigate(['/login']);
                },1000);
              } else{console.log(d)}
            });
            });
     }


     submit(){
      const formData = new FormData();
        formData.append('uid', this.uid.toString());
        formData.append('amount', this.event.amount);
        formData.append('event_type', this.event.event_type);
        formData.append('event_id', this.event.id.toString());
        formData.append('transaction_no', "");
        formData.append('transaction_image',this.imageUrl);
        formData.append('utr_number', this.utrNumber);
        this.api.Post(MYEVENTS, formData).then(data => {
          if(data['status'] == 201){
            this.showPaymentMethod = false;
            this.api.onSuccess(data['message'],'Order No : ' + data['order_no']);
          }
          console.log(data);
        }).catch(d=>{
          if(d.status == 401 || d.status == 503){
            this.api.onFail('Your session is expired please login again','Log in');
            this.api.setGoto();
            this.api.setlogin(0);
            this.api.logout();
            setTimeout(() => {
            this.router.navigate(['/login']);
            },1000);
          } else{document.getElementById('openmodalbutton2').click();}
        });
     }

     register() {
      if (!this.event.amount || this.event.amount == 0) {
       this.api.Post(MYEVENTS, {uid:this.uid, amount:'0' , event_type:'free', event_id:this.event.id.toString(), transaction_no:"000000"}).then(data => {
            console.log(data);
            this.api.onSuccess('Your Registration is done for this Event','Order Successfull');
        }).catch(d=>{
          if(d.status == 503){
            this.api.onFail('Your session is expired please login again','Log In');
            this.api.setGoto();
            this.api.setlogin(0);
            this.api.logout();
            setTimeout(() => {
            this.router.navigate(['/login']);
            },1000);
          } else{
            console.log(d);
            document.getElementById('openmodalbutton2').click();;
          }
        });
      } else {
        this.showPaymentMethod = true
      }
    }

    payWithRazor(amt) {
      const options: any = {
        key: 'rzp_test_NFAvKli4cunoJu',
        amount: amt, // amount should be in paise format to display Rs 1255 without decimal point
        currency: 'INR',
        name: 'Gouri Gold', // company name or product name
        description: '',  // product description
        image: '../../assets/img/logo.png', // company logo or product image
      //  order_id: val, // order_id created by you in backend
        modal: {
          // We should prevent closing of the form when esc key is pressed.
          escape: false,
        },
        notes: {
          // include notes if any
        },
        theme: {
          color: '#efa300'
        }
      };
      options.handler = ((response, error) => {
        options.response = response;
        const formData = new FormData();
        formData.append('uid', this.uid.toString());
        formData.append('amount', amt);
        formData.append('event_type', this.event.event_type);
        formData.append('event_id', this.event.id.toString());
        formData.append('transaction_no', response.razorpay_payment_id);
        this.transaction = response.razorpay_payment_id;
        this.api.Post(MYEVENTS, formData).then(data => {
          console.log(data);
        }).catch(d=>{
          if(d.status == 401 || d.status == 503){
            this.api.onFail('Your session is expired please login again','Log in');
            this.api.setGoto();
            this.api.setlogin(0);
            this.api.logout();
            setTimeout(() => {
            this.router.navigate(['/login']);
            },1000);
          } else{document.getElementById('openmodalbutton2').click();}
        });
        console.log(response);
        console.log(options);
        // call your backend api to verify payment signature & capture transaction
      });
      options.modal.ondismiss = (() => {
        // handle the case when user closes the form while transaction is in progress
        console.log('Transaction cancelled.');
      });
      const rzp = new this.winRef.nativeWindow.Razorpay(options);
      rzp.open();
    }
  
    ngOnInit(){
      this.loader=true;
      this.page=false;
    }
  
  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      const reader = new FileReader();

      reader.onload = () => {
        this.imageUrl = reader.result as string;
      };

      reader.readAsDataURL(file); // Convert to base64
    }
  }

  removeImage() {
    this.imageUrl = null;
  }
    
 
  
  }
